import { IconMinus, IconPlus } from "@hawkins/assets";
import { Box, Button } from "@hawkins/components";
import { useFieldArray } from "@hawkins/forms";
import { Dimensions } from "@hawkins/variables";

interface RepeaterProps {
  name: string;
  componentGenerator: (index: number) => JSX.Element;
  defaultValueGenerator: () => any;
  removeText: string;
  addText: string;
  disabled?: boolean;
  max?: number;
  methods: any;
}

export function Repeater({
  name,
  componentGenerator,
  defaultValueGenerator,
  removeText,
  addText,
  methods,
  disabled = false,
}: RepeaterProps) {
  const { append, fields, remove } = useFieldArray({
    control: methods.control,
    name,
  });

  return (
    <Box rowGap={Dimensions.Space16} paddingTop={Dimensions.Space16} display="grid">
      {fields.map((_, index) => (
        <Box
          display="grid"
          gridTemplateColumns={"85% 15%"}
          placeItems="flex-start"
          alignItems="end"
        >
          <Box width="100%" paddingRight={Dimensions.Space8}>
            {componentGenerator(index)}
          </Box>
          <Box>
            <Button
              disabled={disabled}
              icon={IconMinus}
              onClick={() => remove(index)}
              variant="secondary"
              data-testid={`repeater-remove-button-${index}`}
            >
              {removeText}
            </Button>
          </Box>
        </Box>
      ))}
      <Box>
        <Button
          disabled={disabled}
          icon={IconPlus}
          onClick={() => append(defaultValueGenerator())}
          variant="secondary"
          data-testid="repeater-add-button"
        >
          {addText}
        </Button>
      </Box>
    </Box>
  );
}
